export function joinPaths(path1, path2) {
  // 去除路径开头和结尾的空格
  path1 = path1.trim();
  path2 = path2.trim();

  // 去除路径结尾的 "/"
  path1 = path1.replace(/\/+$/, '');
  // 去除路径开头的 "/"
  path2 = path2.replace(/^\/+/, '');

  // 拼接路径，确保中间只有一个 "/"
  return path1 + '/' + path2;
}
